export default "__VITE_ASSET__FrK0NJCl__"